import { type LocaleDefinition } from '@solinkcorp/locale';
import { type IEvent } from 'clients/PlatformApi';
import { type CamerasDictionary, type VideoDiscoverySite } from 'utils/types';

/**
 * Given an event and the index of a camera within the event, find the associated
 * location and callhome camera.
 */
export function findCamera(
  locale: LocaleDefinition,
  masterLocationsList: VideoDiscoverySite[],
  camerasDictionary: CamerasDictionary,
  event: IEvent,
  camIdx: number,
) {
  let warning;
  let eventCamera;

  if (event.cameras.length === 0) {
    warning = locale.camera.noCamera;
    eventCamera = undefined;
  } else {
    eventCamera = event.cameras[camIdx] || {};

    if (!eventCamera.streams) {
      eventCamera.streams = [];
    }

    if (eventCamera.streams.length === 0) {
      // TODO: Localize
      warning = `No stream for camera ${eventCamera.name}`;
    }
  }

  const location = masterLocationsList.find(({ id }) => id === event.siteId);
  let callhomeCamera = undefined;

  if (eventCamera) {
    const vmsCameraId = eventCamera.id;

    if (eventCamera.chId) {
      // If the camera has a callhome ID, then look it up in the camerasDictionary.
      callhomeCamera = camerasDictionary[eventCamera.chId];
    }

    if (location && !callhomeCamera) {
      // Sometimes it does not... in this case, look it up in the location itself.
      callhomeCamera = location.cameras.find((camera) => camera.cameraId === vmsCameraId);
    }
  }

  return {
    location,
    eventCamera,
    vmsCameraId: eventCamera?.id,
    callhomeCamera,
    chCameraId: callhomeCamera?.id,
    warning,
  };
}
